import React from 'react';
import AnnouncementWarningBars from './AnnouncementWarningBars';
import AlertWarningBars from './AlertWarningBars';
import {useSelector} from 'react-redux';
import {selectAnnouncementsLength} from '../../selectors';

export interface WarningBarsProps {
    canViewAnnouncements?: boolean;
    canViewAlerts?: boolean;
    messages: Record<string, string>;
}

const WarningBars: React.FC<WarningBarsProps> = ({
    canViewAnnouncements = true,
    canViewAlerts = false,
    messages
}) => {
    const announcementsLength = useSelector(selectAnnouncementsLength);

    if (!canViewAnnouncements && !canViewAlerts) {
        return null;
    }

    return (
        <>
            {canViewAnnouncements && !!announcementsLength && <AnnouncementWarningBars />}
            {canViewAlerts && <AlertWarningBars messages={messages} />}
        </>
    );
};

export default WarningBars;
